import { forwardRef } from "react"
import { mergeClasses } from "@lib/css"

import type { IconProps } from "./types"

export const IconChevronRight = forwardRef<SVGSVGElement, IconProps>(
  function IconChevronRight(props, ref) {
    const { className, title, titleId, ...otherProps } = props
    const defaultClasses =
      "w-6 h-6 flex-shrink-0 transition-colors duration-150 ease-in focus:outline-none"
    const classes = mergeClasses(defaultClasses, className)

    return (
      <svg
        ref={ref}
        viewBox="0 0 24 24"
        fill="none"
        focusable="false"
        aria-hidden="true"
        tabIndex={-1}
        className={classes}
        aria-labelledby={titleId}
        {...otherProps}
      >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
          d="M8.36235 21.3001L16.3124 12.3001C16.3846 12.2168 16.4244 12.1103 16.4244 12.0001C16.4244 11.8898 16.3846 11.7833 16.3124 11.7001L8.36235 2.70006C8.32307 2.65556 8.27537 2.61927 8.22201 2.59328C8.16864 2.56729 8.11066 2.55211 8.05141 2.54863C7.99215 2.54514 7.93279 2.55341 7.87675 2.57297C7.8207 2.59252 7.76908 2.62297 7.72485 2.66256C7.63672 2.74295 7.58348 2.8546 7.57647 2.97368C7.56947 3.09277 7.60926 3.20988 7.68735 3.30006L15.3749 12.0001L7.68735 20.7001C7.60925 20.7902 7.56947 20.9073 7.57647 21.0264C7.58348 21.1455 7.63672 21.2572 7.72485 21.3376C7.76908 21.3771 7.8207 21.4076 7.87675 21.4271C7.93279 21.4467 7.99215 21.455 8.05141 21.4515C8.11066 21.448 8.16864 21.4328 8.22201 21.4068C8.27537 21.3808 8.32307 21.3446 8.36235 21.3001Z"
          fill="currentColor"
        />
      </svg>
    )
  },
)
